/**
 * Empty state component shown when there are no messages.
 */

import React from 'react';
import { Box, Typography } from '@mui/material';

export const ChatEmptyState: React.FC = () => {
  return (
    <Box sx={{ textAlign: 'center', color: 'text.secondary', mt: 4 }}>
      <Typography variant="par01Regular">
        Hello! I&apos;m your AI financial planning assistant. Ask me questions about your financial plan, goals, assets, or tax information. Need help? Just ask &quot;help&quot; or &quot;how do I...&quot; to learn about plan result types and what you can ask for.
      </Typography>
    </Box>
  );
};

